<header [class.disable-select-date]="disableSelectDate">
	<app-icon [class.disabled]="isDisabled" class="left-icon" (click)="switchMonth(date, false);$event.stopPropagation();">arrow_back
	</app-icon>
	<div class="button" (click)="getYear(value);$event.stopPropagation();">
		{{capitalize(date | date:'LLLL, yyyy')}}</div>
	<app-icon [class.disabled]="isDisabled" class="right-icon" (click)="switchMonth(date, true);$event.stopPropagation();">
		arrow_forward</app-icon>
</header>
<ul>
	<li *ngFor="let day of daysOfWeek;index as i" [class.isWeekend]="isWeekendConsiderRole(i)">{{day}}</li>
</ul>
<app-grid-drawer [columns]="7" [rows]="6" [items]="days">
	<ng-template #itemTemplate let-item>
		<div class="grid-item" [class.weekend]="isWeekend(item.date.getDay())" [class.outside]="item.isOutside"
			[class.today]="isToday(item.date)" (click)="setDay(item.date)" [class.selected]="isSelected(item.date)"
			[class.disabled]="disabled(item.date)"
			[class.disable-select-date]="disableSelectDate">
			{{item.date.getDate()}}</div>
	</ng-template>
</app-grid-drawer>
